import React from 'react';
import { 
  BarChart3, 
  MessageSquare, 
  Lightbulb, 
  Bot,
  ChartLine
} from 'lucide-react';

const ResultsSidebar = ({ activeTab, onTabChange, hideHeader = false }) => {
  const navigationItems = [
    {
      id: 'Insights',
      label: 'Survey summary stats',
      icon: BarChart3,
      description: 'Overview of survey performance'
    },
    {
      id: 'Responses',
      label: 'Individual responses',
      icon: MessageSquare,
      description: 'View detailed responses'
    },
    {
      id: 'Overview',
      label: 'Analyze results',
      icon: ChartLine,
      description: 'AI-powered insights'
    },
    {
      id: 'Research Assistant',
      label: 'Research Assistant',
      icon: Bot,
      description: 'AI research assistant'
    }
  ];

  return (
    <div className="w-72 bg-white h-full flex flex-col">
      {/* Header */}
      {!hideHeader && (
        <div className="p-4">
          <h1 className="text-lg font-normal text-gray-900">Results</h1>
        </div>
      )}

      {/* Navigation */}
      <div className="flex-1 p-3">
        <nav className="space-y-1">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => !item.comingSoon && onTabChange(item.id)}
                className={`w-full flex items-center gap-3 p-3 rounded-lg transition-all duration-200 text-left group ${
                  isActive
                    ? 'bg-blue-50 text-blue-700 shadow-sm'
                    : item.comingSoon
                    ? 'text-gray-400 cursor-not-allowed'
                    : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                }`}
                disabled={item.comingSoon}
              >
                <div className={`p-1.5 rounded-md ${
                  isActive 
                    ? 'bg-blue-100 text-blue-700' 
                    : item.comingSoon
                    ? 'bg-gray-100 text-gray-400'
                    : 'bg-gray-100 text-gray-600 group-hover:bg-gray-200'
                }`}>
                  <Icon size={18} />
                </div>
                
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className={`text-sm font-normal whitespace-nowrap ${
                      isActive ? 'text-blue-900' : item.comingSoon ? 'text-gray-400' : 'text-gray-900'
                    }`}>
                      {item.label}
                    </span>
                    {item.badge && (
                      <span className="bg-yellow-100 text-yellow-800 px-1.5 py-0.5 text-xs font-normal rounded-full whitespace-nowrap">
                        {item.badge}
                      </span>
                    )}
                    {item.comingSoon && (
                      <div className="flex items-center gap-1">
                        <span className="text-xs text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                          Coming Soon
                        </span>
                        <div className="w-1 h-1 bg-gray-300 rounded-full"></div>
                      </div>
                    )}
                  </div>
                </div>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default ResultsSidebar;